<template>
  <el-dialog
    :visible.sync="showRegister"
    custom-class="dialog"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    >
    <div class="head-pic">
      <el-upload
        class="avatar-uploader"
        action="#"
        :show-file-list="false"
        :http-request="afterRead">
        <img v-if="form.headpicUrl" class="img" :src="form.headpicUrl">
        <div v-else>
          <img class="img" src="@/assets/register/default.png" alt="">
          <img class="camera" src="@/assets/register/camera.png" alt="" srcset="">
        </div>
      </el-upload>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">姓名：</span>
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="label">
        <span class="title required">昵称：</span>
        <el-input v-model="form.nick" placeholder="请输入昵称"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">性别：</span>
        <div class="radioBox">
          <el-radio v-model="form.gender" :label="1">男</el-radio>
          <el-radio v-model="form.gender" :label="2">女</el-radio>
        </div>
      </div>
      <div class="label">
        <span class="title">生日：</span>
        <el-date-picker
          v-model="form.birthday"
          type="date"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          placeholder="选择生日">
        </el-date-picker>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">手机：</span>
        <div class="mobilecode">
          <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" :disabled="isedit"></el-input>
          <el-button v-if="!isedit" class="codeBtn" :disabled="countTime < 60" @click="sendSMS">{{countTime >= 60 ? '获取验证码' : countTime + 's'}}</el-button>
        </div>
      </div>
      <div class="label" v-if="!isedit">
        <span class="title required">验证码：</span>
        <el-input v-model="form.sms_code" placeholder="请输入验证码" maxlength="6"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">用户类型：</span>
        <div class="radioBox">
          <el-radio v-model="form.user_type" :label="1" :disabled="isedit">设计师</el-radio>
          <el-radio v-model="form.user_type" :label="2" :disabled="isedit">经销商</el-radio>
          <el-radio v-model="form.user_type" :label="0" :disabled="isedit">业主</el-radio>
          <el-radio v-model="form.user_type" :label="3" :disabled="isedit">装修经理</el-radio>
        </div>
      </div>
    </div>
    <div class="first-floor" v-if="form.user_type == 1">
      <div class="label">
        <span :class="['title', {'required' : form.user_type == 1}]">所属运营商/专卖店：</span>
        <el-input v-model="form.operator_name" placeholder="请输入所属运营商/专卖店"></el-input>
      </div>
      <div class="label">
        <span :class="['title', {'required' : form.user_type == 1}]">区域经理：</span>
        <el-input v-model="form.area_manager" placeholder="请输入区域经理"></el-input>
      </div>
    </div>
    <div class="first-floor anotherfloor">
      <div class="label">
        <span :class="['title', {'required' : form.user_type == 1 || form.user_type == 3}]">公司名称：</span>
        <el-input v-model="form.organization" placeholder="请输入公司名称"></el-input>
      </div>
      <div class="label anotherlabel" v-if="form.user_type === 1 || form.user_type === 3 ">
        <span class="title">名片：</span>
        <el-upload
          class="visiting-card-uploader"
          action="#"
          :show-file-list="false"
          :http-request="afterReadcard">
          <img v-if="form.visiting_card" :src="form.visiting_card" class="card">
          <img v-else class="card-default" src="@/assets/register/card-default.png">
        </el-upload>
      </div>
    </div>
    <el-button v-if="isedit" class="registerBtn" type="success" :loading="isloading" @click="submitForm">{{isloading ? '保存中...' : '保存'}}</el-button>
    <el-button v-else class="registerBtn" type="success" :loading="isloading" @click="submitForm">{{isloading ? '注册中...' : '注册'}}</el-button>
  </el-dialog>
</template>

<script>
import { upload } from '@/api/tools.js'
import { sendSms, register, editInfo } from '@/api/login.js'
import { isPhone, formatDate } from '@/util/utils.js'
export default {
  name: 'Register',
  components:{ 
  },
  props: {
    showRegister: false,
    userInfo: {},
    isedit: false,
  },
  data() {
    return {
      isloading: false,
      form: {
        mobile: '',
        sms_code: '',
        name: '',
        nick: '',
        address: '',
        gender: 0,
        user_type: '',
        organization: '',
        headpicUrl: '',
        birthday: '',
        visiting_card: '',
        operator_name: '',
        area_manager: ''
      },
      countTime: 60,
      interval: null,
      isClickSMS: false,
      isClickRegister: false
    }
  },
  computed:{ },
  watch: {
    showRegister(olddata, newdata) {
      if (olddata != newdata && !this.isedit) {
        this.form = {
          mobile: '',
          sms_code: '',
          name: '',
          nick: '',
          address: '',
          gender: 0,
          user_type: '',
          organization: '',
          headpicUrl: '',
          birthday: '',
          visiting_card: '',
          // operator_name: ''
        }
      }
    }
  },
  created() {
  },
  mounted() {
    if (this.isedit) {
      this.form = {...this.form, ...this.userInfo}
      this.form.birthday = formatDate(this.form.birthday, 'yyyy/MM/dd')
      this.form.headpicUrl = this.form.headpic
    }
  },
  methods: {
    afterRead(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          this.form.headpicUrl = res.fileLink
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },
    afterReadcard(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          this.form.visiting_card = res.fileLink
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },
    // 发送短信验证码
    sendSMS() {
      if (this.isClickSMS) return
      this.isClickSMS = true
      if (!isPhone(this.form.mobile)) {
        this.$message('请输入手机号')
        this.isClickSMS = false
        return
      }
      if (this.countTime >= 60 ) {
        sendSms({
          mobile: this.form.mobile
        }).then(res => {
          if (res.result === 1) {
            this.countTime--
            this.interval = setInterval(() => {
              if (this.countTime <= 1) {
                clearInterval(this.interval)
                this.countTime = 60
                this.isClickSMS = false
              } else {
                this.countTime--
              }
            }, 1000)
          } else {
            this.$message(res.msg)
            this.countTime = 60
            this.isClickSMS = false
          }
        })
      }
    },
    submitForm() {
      if (this.isClickRegister) return
      this.isClickRegister = true
      if (!this.form.name) {
        this.isClickRegister = false
        this.$message('请输入姓名')
        return
      }
      if (!this.form.nick) {
        this.isClickRegister = false
        this.$message('请输入昵称')
        return
      }
      if (!this.form.gender)  {
        this.isClickRegister = false
        this.$message('请选择性别')
        return
      }
      if (!isPhone(this.form.mobile)) {
        this.isClickRegister = false
        this.$message('请输入手机号')
        return
      }
      if (!this.form.sms_code && !this.isedit)  {
        this.isClickRegister = false
        this.$message('请输入验证码')
        return
      }
      if (this.form.user_type === '')  {
        this.isClickRegister = false
        this.$message('请选择用户类型')
        return
      }
      if (this.form.user_type == 1 || this.form.user_type == 3) {
        if (!this.form.organization) {
          this.isClickRegister = false
          this.$message('请输入公司名称')
        }
      } else {
        this.form.visiting_card = ''
      }
      if (this.form.user_type == 1 && this.form.operator_name === '') {
        this.isClickRegister = false
        this.$message('请输入所属运营商/专卖店')
        return
      }
      if (this.form.user_type == 1 && this.form.operator_name === '') {
        this.isClickRegister = false
        this.$message('请输入区域经理')
        return
      }
      this.isloading = true
      if (this.isedit) {
        editInfo({...this.form}).then(res => {
          if (res.result === 1) {
            res.token = localStorage.getItem('token')
            res.key = localStorage.getItem('key')
            res.deskey = localStorage.getItem('deskey')
            res.validity_time = localStorage.getItem('validity_time')
            this.$emit('saveGiftsUser', res)
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.isloading = false
            this.isClickRegister = false
            this.$emit('unedit', false)
            this.$emit('goregister', false)
          } else {
            this.isloading = false
            this.$message(res.msg)
            this.isClickRegister = false
          }
        })
      } else {
        register({...this.form}).then(res => {
          if (res.result === 1) {
            this.$emit('saveGiftsUser', res)
              this.$message({
                message: '注册成功',
                type: 'success'
              });
              this.isloading = false
              this.isClickRegister = false
              this.$emit('goregister', false)
            } else {
              this.isloading = false
              this.$message(res.msg)
              this.isClickRegister = false
            }
        })
      }
    },
    closeDialog() {
      this.$emit('goregister', false)
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog {
  width: 745px;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 70px 30px 30px 30px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    position: relative;
    .head-pic {
      width: 116px;
      height: 116px;
      position: absolute;
      top: -132px;
      left: 50%;
      transform: translateX(-50%);
      .img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        vertical-align: top;
        object-fit: cover;
      }
      .camera {
        width: 34px;
        height: 26px;
        position: absolute;
        bottom: 6px;
        right: 11px;
      }
      .avatar-uploader, .el-upload {
        width: 100%;
        height: 100%;
      }
    }
    .first-floor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        height: 50px;
        padding: 0 5px;
        border-radius: 26px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .title {
          height: 50px;
          line-height: 50px;
          white-space: nowrap;
          text-align: left;
          &.required {
            position: relative;
            &::before {
              content: '*';
              position: absolute;
              top: 2px;
              left: -10px;
              color: #E83636;
            }
          }
        }
        &:nth-of-type(2) {
          margin-left: 20px;
        }
        .mobilecode {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
          .el-input__inner {
            border: 0;
          }
        }
        .radioBox {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .el-radio__input {
          &.is-checked {
            &+.el-radio__label {
              color: #4E8B46;
            }
            .el-radio__inner {
              background: #4E8B46;
              border-color: #4E8B46;
              &:after {
                width: 100%;
                height: 100%;
                content: '\2714';
                color: #fff;
                background-color: #4E8B46;
              }
            }
          }
        }
        .el-input {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          outline: none;
          font-size: 16px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
        }
        .codeBtn {
          width: 130px;
          height: 44px;
          background: #4E8B46;
          border: 1px solid #4E8B46;
          border-radius: 22px;
          color: #fff;
          margin-right: -7px;
          font-size: 16px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          :hover {
            color: #fff;
          }
          &.is-disabled {
            background: #ccc;
            border-color: #ccc;
          }
        }
        .visiting-card-uploader {
          width: 112px;
          height: 112px;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              vertical-align: top;
            }
          }
        }
        &.anotherlabel {
          height: auto;
          align-items: flex-start;
        }
      }
      &.anotherfloor {
        align-items: flex-start;
      }
    }
    .registerBtn {
      width: 620px;
      height: 60px;
      background: #4E8B46;
      border-radius: 25px 25px 25px 25px;
      font-size: 32px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      -webkit-user-select: none;
      .el-icon-loading {
        font-size: 32px!important;
      } 
    }
  }
}
</style>
<style lang="less">
.el-date-table td.current:not(.disabled) span {
  color: #FFF;
  background-color: #4E8B46;
}
</style>